import Datatable from './views/Datatable.vue'
import GetOnBoard from './views/GetOnBoard.vue'
import PasswordReset from './views/PasswordReset.vue'
import Edit from './views/Edit.vue'
import Login from './views/Login.vue'
import StaticPage from './views/StaticPage.vue'

// function lazyLoad(view){
//     return() => import(`@/views/${view}.vue`)
// }

function getMenu() {
    this.$axios.get(this.$store.state.client_vars.MENU)
    .then(response => {
      this.menuItems = response.data
    })
    .catch(error => console.log('Failed to get menu', error))
}

export default [
    { 
        path: '/', 
        component: Datatable, 
        name: 'Datatable' 
    },
    { 
        path: '/getonboard/:record?', 
        component: GetOnBoard, 
        name: 'GetOnBoard'
    },
    { 
        path: '/edit', 
        component: Edit, 
        name: 'Edit' 
    },
    { 
        path: '/login/:status?', 
        component: Login, 
        name: 'Login' 
    },
    { 
        path: '/static/:page?', 
        component: StaticPage, 
        name: 'Static' 
    },
    { 
        path: '/passwordreset/', 
        component: PasswordReset, 
        name: 'PasswordReset'
    }
]